import { render, staticRenderFns } from "./HotelBatchChange.vue?vue&type=template&id=b7288298&scoped=true"
import script from "./HotelBatchChange.vue?vue&type=script&lang=js"
export * from "./HotelBatchChange.vue?vue&type=script&lang=js"
import style0 from "./HotelBatchChange.vue?vue&type=style&index=0&id=b7288298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7288298",
  null
  
)

export default component.exports